import React from "react";
import Header from "./components/Header/Header";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer/Footer";
import "./App.css";
function App() {
  return (
    <>
      <Header />
      <Projects />
      <Footer />
    </>
  );
}

export default App;
